import moment from "moment";
import { json2csv } from "json-2-csv";

export const dateBeautify = (date) => moment(date).format("MMM DD, yyyy");

export const dateBeautifyAsHrs = (date) =>
  moment(date).format("MMM DD, yyyy HH:mm:ss");

export const convertJSONtoCSV = async (jsonData, filename = "data.csv") => {

  try {


    jsonData?.forEach((dateEntry) => {
      const combinationType =
        dateEntry?.projectList && dateEntry?.projectList[0]?.assigneesList
          ? "DPA"
          : dateEntry.assigneesList && dateEntry.assigneesList[0].projectList
            ? "DAP"
            : dateEntry?.assigneesList && dateEntry?.assigneesList[0]?.dateList
              ? "PAD"
              : dateEntry?.dateList && dateEntry?.dateList[0]?.assigneesList
                ? "PDA"
                : dateEntry?.dateList && dateEntry?.dateList[0].projectList
                  ? "ADP"
                  : dateEntry?.projectList && dateEntry?.projectList[0].dateList
                    ? "APD"
                    : dateEntry?.data
                      ? "TaskFilters"
                      : null;

      switch (combinationType) {
        case "DPA":
          dateEntry.projectList.forEach((project) => {
            // Remove _id field from project

            delete project._id;

            // Iterate over each assignee in the assigneesList and remove _id and profilepic
            project.assigneesList?.forEach((assignee) => {
              delete assignee._id;
              delete assignee.profilepic;

              // Iterate over each task in the tasks array and remove the _id field
              assignee.tasks?.forEach((task) => {
                delete task._id;
                delete task.employeeId;
                delete task.projectId;
                delete task.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = ""; // Default to an empty string if there are no comments
                }

                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {
                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;

        case "DAP":
          dateEntry.assigneesList.forEach((assignee) => {

            // Remove _id field from assigneesList item
            delete assignee.profilepic;
            delete assignee._id;

            // Iterate over projectList and remove _id and profilepic
            assignee.projectList?.forEach((project) => {
              delete project._id;

              // Iterate over tasks and remove the _id field for the tasks
              project.tasks?.forEach((task) => {
                delete task._id;
                delete task.employeeId;
                delete task.projectId;
                delete task.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                // Remove HTML tags from comments
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = "-"; // Default to an empty string if there are no comments
                }
                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {

                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;

        case "PAD":
          delete dateEntry?._id;
          dateEntry?.assigneesList?.forEach((assignee) => {

            // Remove _id field from assigneesList item
            delete assignee?.profilepic;
            delete assignee?._id;

            // Iterate over dateList and remove _id
            assignee?.dateList?.forEach((date) => {
              delete date?._id;

              // Iterate over tasks and remove the _id field for the tasks
              date?.tasks?.forEach((task) => {
                delete task?._id;
                delete task?.employeeId;
                delete task?.projectId;
                delete task?.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                // Remove HTML tags from comments
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = ""; // Default to an empty string if there are no comments
                }

                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {
                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;

        case "PDA":
          delete dateEntry._id;
          dateEntry.dateList.forEach((date) => {

            // Remove _id field from dateList item
            delete date._id;

            // Iterate over assigneesList and remove _id and profilepic
            date.assigneesList?.forEach((date) => {
              delete date._id;
              delete date.profilepic;

              // Iterate over tasks and remove the _id field
              date.tasks?.forEach((task) => {
                delete task._id;
                delete task.employeeId;
                delete task.projectId;
                delete task.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                // Remove HTML tags from comments
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = ""; // Default to an empty string if there are no comments
                }
                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {
                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;

        case "ADP":
          delete dateEntry._id;
          delete dateEntry.profilepic;
          dateEntry.dateList.forEach((date) => {

            // Remove _id field from dateList item
            delete date._id;

            // Iterate over projectList and remove _id
            date.projectList?.forEach((project) => {
              delete project._id;

              // Iterate over tasks and remove the _id field
              project.tasks?.forEach((task) => {
                delete task._id;
                delete task.employeeId;
                delete task.projectId;
                delete task.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                // Remove HTML tags from comments
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = ""; // Default to an empty string if there are no comments
                }

                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {
                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;

        case "APD":
          delete dateEntry._id;
          delete dateEntry.profilepic;
          dateEntry.projectList.forEach((project) => {

            // Remove _id field from projectList item
            delete project._id;

            // Iterate over dateList and remove _id
            project.dateList?.forEach((date) => {
              delete date._id;

              // Iterate over tasks and remove the _id field
              date.tasks?.forEach((task) => {
                delete task._id;
                delete task.employeeId;
                delete task.projectId;
                delete task.taskstatus._id;

                // Format createddate using the dateBeautify function
                task.createddate = dateBeautify(task.createddate);
                task.actual_start_date = dateBeautify(task?.actual_start_date);
                task.actual_due_date = dateBeautify(task?.actual_due_date);
                // New Fields
                task.estimated_time = task.estimated_time || "";
                task.actual_time = task.actual_time || "";
                task.sprint_tag = Array.isArray(task.sprint_tag)
                  ? task.sprint_tag.join(" , ")
                  : task.sprint_tag || "";
                // Remove HTML tags from comments
                if (Array.isArray(task.comments) && task.comments.length > 0) {
                  task.comments = task.comments
                    .map((comment) => comment.replace(/<\/?[^>]+(>|$)/g, ""))
                    .join(", ");
                } else if (
                  typeof task.comments === "string" &&
                  task.comments.trim() !== ""
                ) {
                  task.comments = task.comments.replace(/<\/?[^>]+(>|$)/g, "");
                } else {
                  task.comments = ""; // Default to an empty string if there are no comments
                }

                // Remove log_time and estimation_time from subtasks
                task.subtasks?.forEach((subtaskArray) => {
                  subtaskArray.forEach((subtask) => {
                    delete subtask.log_time; // Remove log_time
                    delete subtask.estimation_time; // Remove estimation_time
                  });
                });
              });
            });
          });
          break;



        case "TaskFilters":
          const tasks = Array.isArray(dateEntry.data) ? dateEntry.data : [dateEntry.data];

          tasks.forEach((task) => {
            if (Array.isArray(task.description) && task.description.length > 0) {
              task.description = task.description
                .map((description) => description.replace(/<\/?[^>]+(>|$)/g, ""))
                .join(", ");
            } else if (
              typeof task.description === "string" &&
              task.description.trim() !== ""
            ) {
              task.description = task.description.replace(/<\/?[^>]+(>|$)/g, "");
            } else {
              task.description = "-";
            }

            const filteredTask = {
              taskId: task.taskId || "-",
              name: task.name || "-",
              status: task.status?.name || "-",
              priority: task.priority || "-",
              estimation_time: task.estimation_time || 0,
              log_time: task.log_time || 0,
              start_date: dateBeautify(task.start_date) || "-",
              due_date: dateBeautify(task.due_date) || "-",
              members: Array.isArray(task.members)
                ? task.members.map((member) => member.name || member).join(', ')
                : typeof task?.members === "string"
                  ? task?.members
                  : "-",

              createdByName: task.createdBy?.name || "-",
              createdAt: dateBeautify(task.createddate) || "-",
              updatedAt: dateBeautify(task.updatedAt) || "-",
              description: task.description,
              sprintTags: Array.isArray(task.sprint_tag)
                ? task?.sprint_tag.join(', ')
                : typeof task?.sprint_tag === "string"
                  ? task?.sprint_tag
                  : "-",
              actualStartDate: dateBeautify(task.actualStartDate) || "-",
              actualDueDate: dateBeautify(task.actual_due_date) || "-",
              subTasks: task.subTasks?.map((subtask) => ({
                subtaskId: subtask._id || "-",
                subtaskName: subtask.name || "-"
              })) || []
            };

            dateEntry.data = Array.isArray(dateEntry.data) ? dateEntry.data.map(() => filteredTask) : [filteredTask];
          });
          break;



        default:
          console.log("No valid combination found");
          break;
      }
    });

    // Define custom header mappings
    const headerMappings = {
      projectName: "Project Name",
      "assigneesList.name": "Assignee Name",
      "dateList.projectList.tasks.subtasks.name": "SubTask Name",
      "dateList.projectList.tasks.subtasks._id": "SubTask Id",
      "projectList.dateList.tasks.subtasks._id": "SubTask Id",
      "projectList.dateList.tasks.subtasks.name": "SubTask Name",
      "assigneesList.dateList.tasks.subtasks._id": "SubTask Id",
      "assigneesList.dateList.tasks.subtasks.name": "SubTask Name",
      "assigneesList.dateList.tasks.actual_start_date": "Actual Start Date",
      "assigneesList.dateList.tasks.actual_due_date": "Actual End Date",
      "dateList.assigneesList.tasks.subtasks._id": "SubTask Id",
      "dateList.assigneesList.tasks.subtasks.name": "SubTask Name",
      "projectList.dateList.tasks.actual_start_date": "Actual Start Date",
      "projectList.dateList.tasks.actual_due_date": "Actual Due Date",
      "assigneesList.dateList.tasks.subtasks": "SubTask",
      "projectList.dateList.tasks.subtasks": "SubTask",
      "tasks.taskName": "Task Name",
      "tasks.taskId": "Task Id",
      "tasks.subtaskId": "SubTask Id",
      "tasks.subtaskName": "SubTask Name",
      "tasks.taskstatus.name": "Task Status",
      "tasks.createddate": "Created Date",
      "tasks.totalhours": "SubTaskWise Total Hours",
      "tasks.comments": "Description",
      "tasks.estimated_time": "Estimated Time",
      "tasks.actual_time": "Actual Time",
      "tasks.sprint_tag": "Tags",
      "data.taskId": "Task Id",
      "data.name": "Task Name",
      "data.subTasks.subtaskId": "Subtask Id",
      "data.subTasks.subtaskName": "Subtask Name",
      "data.status": "Task Status",
      "data.priority": "Priority",
      "data.estimation_time": "Estimated Time",
      "data.log_time": "Log Time",
      "data.start_date": "Start Date",
      "data.due_date": "Due Date",
      "data.members": "Assignee Names",
      "data.description": "Description",
      "data.subTasks": "Subtask Data",
      "data.createdByName": "Created By",
      "data.createdAt": "Created Date",
      "data.updatedAt": "Updated Date",
      "data.sprintTags": "Sprint Tags",
      "data.actualStartDate": "Actual Start Date",
      "data.actualDueDate": "Actual End Date",
      "projectList.tasks": "Tasks",
      "assigneesList.task": "Tasks",
      _id: "Date",
      projectTotal: "Project Total",
      assigneesTotal: "Assignees Total",
      dateTotal: "Date Total",
      name: "Name",
      taskName: "Task Name",
      taskId: "Task Id",
      estimated_time: "Estimated Time",
      actual_time: "Actual Time",
      sprint_tag: "Tags",
      createddate: "Created Date",
      comments: "Description",



    };

    // Function to find the mapping value based on partial match
    const getMappedHeader = (header) => {
      for (const [key, value] of Object.entries(headerMappings)) {
        if (header.includes(key)) {
          return value;
        }
      }
      return header;
    };
    // Convert JSON to CSV
    const csvData = json2csv(jsonData, {
      emptyFieldValue: "",
      excelBOM: true,
      //   expandNestedObjects: true,
      //   expandArrayObjects: true,
      unwindArrays: true,
    });

    // Split CSV into lines
    const csvLines = csvData.split("\n");

    // Original headers line
    const originalHeaders = csvLines[0].split(",");

    const mappedHeaders = originalHeaders.map((header) =>
      getMappedHeader(header.trim())
    );
    // Replace the first line with mapped headers
    csvLines[0] = mappedHeaders.join(",");

    // Join lines back into a single CSV string
    const updatedCsv = csvLines.join("\n");

    // Download the CSV file
    downloadCSV(updatedCsv, filename);
  } catch (err) {
    console.error("Error converting JSON to CSV:", err);
  }
};

// Helper function to trigger CSV download
function downloadCSV(content, filename) {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
